import React, { useEffect, useState } from "react";
import { createRequestOutbound, fetchAllOutboundByType } from "../../resources/OutboundResource";
import DataTable from 'react-data-table-component';
import { format } from "date-fns";
import { fetchInboundByRFID } from "../../resources/InboundResource";
import { showSuccessToast } from "../../utils/GlobalToast";
import { getLocalAuth } from "../../utils/AuthUtils";
import ErrorNotFound from "../errors/Error";

function RequestPart() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "Request Part"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  const [dataOutbound, setDataOutbound] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const [purpose, setPurpose] = useState("");
  const [requestBy, setRequestBy] = useState("");
  const [rfid, setRfid] = useState("");

  const [part, setPart] = useState("");
  const [qty, setQty] = useState("");
  const [batch, setBatch] = useState("");
  const [productionDate, setProductionDate] = useState("");
  const [tracking, setTracking] = useState("");
  const [shift, setShift] = useState("");
  const [rack, setRack] = useState("");
  const [scanRequest, setScanRequest] = useState("");
  const [outboundItem, setOutboundItem] = useState([]);

  const [showModalRequest, setShowModalRequest] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const [dateFilter, setDateFilter] = useState("");

  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchOutbound = () => {
    fetchAllOutboundByType(0, dateFilter === "" ? "" : format(dateFilter, "yyyy-MM-dd").toString())
      .then((res) => {
        setDataOutbound(res.data);
      })
      .catch((err) => {
        setDataOutbound([]);
      });
  };

  useEffect(() => {
    fetchOutbound();

    // eslint-disable-next-line
  }, [refreshKey]);

  const handleData = (data) => {
    setRequestBy(data.user === null ? "-" : data.user.name);
    setPurpose(data.purpose);
    setOutboundItem(data.outbound_items);
  }

  const fetchInbound = (scanRequest) => {
    fetchInboundByRFID(scanRequest).then((res) => {
      setRfid(res.data.rfid.rfid_number);
      setPart(res.data.part.part_number);
      setQty(res.data.qty);
      setBatch(res.data.batch);
      setProductionDate(format(res.data.production_date, "yyyy-MM-dd").toString());
      setTracking(res.data.tracking);
      setShift(res.data.shift);
      setRack(res.data.rack.name)
      setScanRequest("");
      setShowModalDetail(true);
    }).catch((err) => {
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
    });

  }

  const onChangeScanRequestAdd = (e) => {
    setScanRequest(e.target.value);
    if (e.target.value.length > 20) {
      fetchInbound(e.target.value);
    } else {
      setShowModalDetail(false);
    }
  }

  const onSaveItem = () => {
    setIsLoading(true);

    outboundItem.forEach((data) => {
      data.outbound_item_outs.forEach(async (item, index) => {
        await createRequestOutbound(item.outbound_item_id, item.rfid.rfid_number, item.qty, item.production_date).then((res) => {
          if (data.outbound_item_outs.length === (index + 1)) {
            setIsLoading(false);
            setIsError(false);
            showSuccessToast("Success Requested Part!");
            setShowModalRequest(false);
            setShowModalDetail(false);
            setScanRequest("");
            setRequestBy("");
            setPurpose("");
            fetchOutbound();
          }
        }).catch((err) => {
          setIsLoading(false);
          setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
          setIsError(true);
        });
      })
    });
  }

  const columnsRequest = [
    {
      name: 'Part',
      selector: row => row.part.part_number,
      width: '180px'
    },
    {
      name: 'QTY',
      selector: row => row.qty,
      width: '80px'
    },
    {
      name: 'RFID',
      selector: row => row.outbound_item_outs.map((data) => {
        return <div key={data.id}>{data.rfid === null ? '-' : data.rfid.rfid_number}</div>;
      }),
    },
    {
      name: 'QTY',
      selector: row => row.outbound_item_outs.map((data) => {
        return <div key={data.id}>{data.qty}</div>;
      }),
      width: '80px'
    },
    {
      name: 'Production Date',
      selector: row => row.outbound_item_outs.map((data) => {
        return <div key={data.id}>{data.production_date === null ? "-" : format(data.production_date, "yyyy-MM-dd").toString()}</div>;
      }),
      width: '150px'
    },
  ];

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Request By',
      selector: row => row.user === null ? "-" : row.user.name,
      sortable: true,
    },
    {
      name: 'Purpose',
      selector: row => row.purpose,
      sortable: true,
    },
    {
      name: 'Part',
      selector: row => row.outbound_items.map((data) => {
        return (<div key={data.id}>{`${data.part.name}`}</div>);
      }),
      sortable: true,
      width: '180px',
    },
    {
      name: 'QTY',
      selector: row => row.outbound_items.map((data) => {
        return (<div key={data.id}>{`${data.qty}`}</div>);
      }),
      sortable: true,
      width: '80px'
    },
    {
      name: 'Status',
      width: '120px',
      selector: row =>
      (row.status === 0 ? <a
        href="#section"
        className="btn btn-sm btn-light-warning btn-block radius-30"
      >
        Waiting
      </a> : row.status === 1 ? <a
        href="#section"
        className="btn btn-sm btn-light-success btn-block radius-30"
      >
        Done
      </a> : <a
        href="#section"
        className="btn btn-sm btn-light-danger btn-block radius-30"
      >
        Decline
      </a>),
      sortable: true,
    },
    {
      name: 'Progress',
      width: '120px',
      selector: row =>
      (row.progress === null ? '-' : row.progress <= 50 ? <a
        href="#section"
        className="btn btn-sm btn-light-info btn-block radius-30"
      >
        {`${row.progress}%`}
      </a> : row.progress >= 51 && row.progress <= 99 ? <a
        href="#section"
        className="btn btn-sm btn-light-warning btn-block radius-30"
      >
        {`${row.progress}%`}
      </a> : <a
        href="#section"
        className="btn btn-sm btn-light-success btn-block radius-30"
      >
        {`${row.progress}%`}
      </a>),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          <button type="button" style={{ marginRight: "8px" }} className="btn btn-info" onClick={() => {
            handleData(row);
            setShowModalRequest(true);
          }}>View</button>
          <div className={`modal fade ${showModalRequest ? 'show' : ''}`} style={{ display: showModalRequest ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Request Part</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModalRequest(false)} aria-label="Close"></button>
                </div>
                {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label className="form-label fw-bold">RFID</label>
                      <input autoFocus type="text" className="form-control" value={scanRequest} onChange={onChangeScanRequestAdd} placeholder="Scan Here" />
                    </div>
                    <div className="mb-3">
                      <div className="row">
                        <div className="col">
                          <label className="form-label fw-bold">User Request</label>
                          <input required disabled type="text" className="form-control" value={requestBy} onChange={(e) => setRequestBy(e.target.value)} />
                        </div>
                        <div className="col">
                          <label className="form-label fw-bold">Purpose</label>
                          <input required disabled type="text" className="form-control" value={purpose} onChange={(e) => setPurpose(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">List Request</label>
                      <DataTable
                        columns={columnsRequest}
                        data={outboundItem}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className={`modal fade ${showModalDetail ? 'show' : ''}`} style={{ display: showModalDetail ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Detail Part</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                    setShowModalDetail(false);
                  }}></button>
                </div>
                {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label fw-bold">RFID</label>
                    <input required disabled type="text" className="form-control" value={rfid} onChange={(e) => setRfid(e.target.value)} />
                  </div>
                  <div className="mb-3">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Part</label>
                        <input required disabled type="text" className="form-control" value={part} onChange={(e) => setPart(e.target.value)} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">QTY</label>
                        <input required disabled type="number" className="form-control" value={qty} onChange={(e) => setQty(e.target.value)} />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Batch</label>
                        <input required disabled type="text" className="form-control" value={batch} onChange={(e) => setBatch(e.target.value)} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Production Date</label>
                        <input required disabled type="text" className="form-control" value={productionDate} onChange={(e) => setProductionDate(e.target.value)} />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Tracking</label>
                        <input required disabled type="text" className="form-control" value={tracking} onChange={(e) => setTracking(e.target.value)} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Shift</label>
                        <input required disabled type="text" className="form-control" value={shift} onChange={(e) => setShift(e.target.value)} />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label fw-bold">Rack</label>
                    <input required disabled type="text" className="form-control" value={rack} onChange={(e) => setRack(e.target.value)} />
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => {
                      setShowModalDetail(false);
                    }}>Cancel</button>
                    {!isLoading ? <button type="submit" className="btn btn-info" onClick={() => onSaveItem()}>Save</button> :
                      <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row gy-3"><div className="col-md-10">
                    <h4 className="mb-0">Request Part</h4>
                  </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Scan Date:</label>
                    <input type="date" className="form-control" value={dateFilter} onChange={(e) => {
                      setDateFilter(e.target.value);
                      setRefreshKey(refreshKey => refreshKey + 1);
                    }} />
                  </div>
                </div>
                <br />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={dataOutbound}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default RequestPart